<template>
	
	<div>
		<div class="month">      
			<ul>
				<li>
					{{ firstMonth }}<br>
					<span style="font-size:18px">{{ firstYear }}</span>
				</li>
			</ul>
		</div>
		<ul  class="weekdays">
			<!-- <li>Mo</li>
			<li>Tu</li>
			<li>We</li>
			<li>Th</li>
			<li>Fr</li>
			<li>Sa</li>
			<li>Su</li> -->
			<li v-for="(day,index) in weekDaysFirstMonth">{{ day }}</li>
		</ul>
		<ul class="days">  
			<li><span :id="createIdForCalendarDays(1,firstMonth,firstYear)">1</span></li>
			<li><span :id="createIdForCalendarDays(2,firstMonth,firstYear)">2</span></li>
			<li><span :id="createIdForCalendarDays(3,firstMonth,firstYear)">3</span></li>
			<li><span :id="createIdForCalendarDays(4,firstMonth,firstyear)">4</span></li>
			<li><span :id="createIdForCalendarDays(5,firstMonth,firstYear)">5</span></li>
			<li><span :id="createIdForCalendarDays(6,firstMonth,firstYear)">6</span></li>
			<li><span :id="createIdForCalendarDays(7,firstMonth,firstYear)">7</span></li>
			<li><span :id="createIdForCalendarDays(8,firstMonth,firstYear)">8</span></li>
			<li><span :id="createIdForCalendarDays(9,firstMonth,firstYear)">9</span></li>
			<li><span :id="createIdForCalendarDays(10,firstMonth,firstYear)">10</span></li>
			<li><span :id="createIdForCalendarDays(11,firstMonth,firstYear)">11</span></li>
			<li><span :id="createIdForCalendarDays(12,firstMonth.firstYear)">12</span></li>
			<li><span :id="createIdForCalendarDays(13,firstMonth,firstYear)">13</span></li>
			<li><span :id="createIdForCalendarDays(14,firstMonth,firstYear)">14</span></li>
			<li><span :id="createIdForCalendarDays(15,firstMonth,firstYear)">15</span></li>
			<li><span :id="createIdForCalendarDays(16,firstMonth,firstYear)">16</span></li>
			<li><span :id="createIdForCalendarDays(17,firstMonth,firstYear)">17</span></li>
			<li><span :id="createIdForCalendarDays(18,firstMonth,firstYear)">18</span></li>
			<li><span :id="createIdForCalendarDays(19,firstMonth,firstYear)">19</span></li>
			<li><span :id="createIdForCalendarDays(20,firstMonth,firstYear)">20</span></li>
			<li><span :id="createIdForCalendarDays(21,firstMonth,firstYear)">21</span></li>
			<li><span :id="createIdForCalendarDays(22,firstMonth,firstYear)">22</span></li>
			<li><span :id="createIdForCalendarDays(23,firstMonth,firstYear)">23</span></li>
			<li><span :id="createIdForCalendarDays(24,firstMonth,firstYear)">24</span></li>
			<li><span :id="createIdForCalendarDays(25,firstMonth,firstYear)">25</span></li>
			<li><span :id="createIdForCalendarDays(26,firstMonth,firstYear)">26</span></li>
			<li><span :id="createIdForCalendarDays(27,firstMonth,firstYear)">27</span></li>
			<li><span :id="createIdForCalendarDays(28,firstMonth,firstYear)">28</span></li>
			<div class="adjust-bottom-row">
				<li class="space-between-bottom-row-dates"><span :id="createIdForCalendarDays(29,firstMonth,firstYear)">29</span></li>
				<li class="space-between-bottom-row-dates"  :class="firstMonthDays == 30 || firstMonthDays ==31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(30,firstMonth,firstYear)">30</span></li>
				<li class="space-between-bottom-row-dates" :class="firstMonthDays ==31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(31,firstMonth,firstYear)">31</span></li>
			</div>
		
		</ul>
	</div>
    <div>
		<div class="month">      
			<ul>
				<li>
					{{ secondMonth }}<br>
					<span style="font-size:18px">{{ secondYear }}</span>
				</li>
			</ul>
		</div>
		<ul class="weekdays">
			<li v-for="(day,index) in weekDaysSecondMonth">{{ day }}</li>
			<!-- <li>Tu</li>
			<li>We</li>
			<li>Th</li>
			<li>Fr</li>
			<li>Sa</li>
			<li>Su</li> -->
		</ul>
		<ul class="days">  
			<li><span :id="createIdForCalendarDays(32,secondMonth,secondYear)">1</span></li>
			<li><span :id="createIdForCalendarDays(33,secondMonth,secondYear)">2</span></li>
			<li><span :id="createIdForCalendarDays(34,secondMonth,secondYear)">3</span></li>
			<li><span :id="createIdForCalendarDays(35,secondMonth,secondYear)">4</span></li>
			<li><span :id="createIdForCalendarDays(36,secondMonth,secondYear)">5</span></li>
			<li><span :id="createIdForCalendarDays(37,secondMonth,secondYear)">6</span></li>
			<li><span :id="createIdForCalendarDays(38,secondMonth,secondYear)">7</span></li>
			<li><span :id="createIdForCalendarDays(39,secondMonth,secondYear)">8</span></li>
			<li><span :id="createIdForCalendarDays(40,secondMonth,secondYear)">9</span></li>
			<li><span :id="createIdForCalendarDays(41,secondMonth,secondYear)">10</span></li>
			<li><span :id="createIdForCalendarDays(42,secondMonth,secondYear)">11</span></li>
			<li><span :id="createIdForCalendarDays(43,secondMonth,secondYear)">12</span></li>
			<li><span :id="createIdForCalendarDays(44,secondMonth,secondYear)">13</span></li>
			<li><span :id="createIdForCalendarDays(45,secondMonth,secondYear)">14</span></li>
			<li><span :id="createIdForCalendarDays(46,secondMonth,secondYear)">15</span></li>
			<li><span :id="createIdForCalendarDays(47,secondMonth,secondYear)">16</span></li>
			<li><span :id="createIdForCalendarDays(48,secondMonth,secondYear)">17</span></li>
			<li><span :id="createIdForCalendarDays(49,secondMonth,secondYear)">18</span></li>
			<li><span :id="createIdForCalendarDays(50,secondMonth,secondYear)">19</span></li>
			<li><span :id="createIdForCalendarDays(51,secondMonth,secondYear)">20</span></li>
			<li><span :id="createIdForCalendarDays(52,secondMonth,secondYear)">21</span></li>
			<li><span :id="createIdForCalendarDays(53,secondMonth,secondYear)">22</span></li>
			<li><span :id="createIdForCalendarDays(54,secondMonth,secondYear)">23</span></li>
			<li><span :id="createIdForCalendarDays(55,secondMonth,secondYear)">24</span></li>
			<li><span :id="createIdForCalendarDays(56,secondMonth,secondYear)">25</span></li>
			<li><span :id="createIdForCalendarDays(57,secondMonth,secondYear)">26</span></li>
			<li><span :id="createIdForCalendarDays(58,secondMonth,secondYear)">27</span></li>
			<li><span :id="createIdForCalendarDays(59,secondMonth,secondYear)">28</span></li>
			<div class="adjust-bottom-row">
				<li class="space-between-bottom-row-dates"><span :id="createIdForCalendarDays(60,secondMonth,secondYear)">29</span></li>
				<li class="space-between-bottom-row-dates" :class="secondMonthDays == 30 || secondMonthDays == 31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(61,secondMonth,secondYear)">30</span></li>
				<li class="space-between-bottom-row-dates" :class="secondMonthDays == 31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(62,secondMonth,secondYear)">31</span></li>
			</div>
		</ul>
	</div>
    <div>
		<div class="month">      
			<ul>
				<li>
					{{ thirdMonth }}<br>
					<span style="font-size:18px">{{ thirdYear }}</span>
				</li>
			</ul>
		</div>
		<ul class="weekdays">
			<!-- <li>Mo</li>
			<li>Tu</li>
			<li>We</li>
			<li>Th</li>
			<li>Fr</li>
			<li>Sa</li>
			<li>Su</li> -->
			<li v-for="(day,index) in weekDaysThirdMonth">{{ day }}</li>
		</ul>
		<ul class="days">  
			<li><span :id="createIdForCalendarDays(63,thirdMonth,thirdYear)">1</span></li>
			<li><span :id="createIdForCalendarDays(64,thirdMonth,thirdYear)">2</span></li>
			<li><span :id="createIdForCalendarDays(65,thirdMonth,thirdYear)">3</span></li>
			<li><span :id="createIdForCalendarDays(66,thirdMonth,thirdYear)">4</span></li>
			<li><span :id="createIdForCalendarDays(67,thirdMonth,thirdYear)">5</span></li>
			<li><span :id="createIdForCalendarDays(68,thirdMonth,thirdYear)">6</span></li>
			<li><span :id="createIdForCalendarDays(69,thirdMonth,thirdYear)">7</span></li>
			<li><span :id="createIdForCalendarDays(70,thirdMonth,thirdYear)">8</span></li>
			<li><span :id="createIdForCalendarDays(71,thirdMonth,thirdYear)">9</span></li>
			<li><span :id="createIdForCalendarDays(72,thirdMonth,thirdYear)">10</span></li>
			<li><span :id="createIdForCalendarDays(73,thirdMonth,thirdYear)">11</span></li>
			<li><span :id="createIdForCalendarDays(74,thirdMonth,thirdYear)">12</span></li>
			<li><span :id="createIdForCalendarDays(75,thirdMonth,thirdYear)">13</span></li>
			<li><span :id="createIdForCalendarDays(76,thirdMonth,thirdYear)">14</span></li>
			<li><span :id="createIdForCalendarDays(77,thirdMonth,thirdYear)">15</span></li>
			<li><span :id="createIdForCalendarDays(78,thirdMonth,thirdYear)">16</span></li>
			<li><span :id="createIdForCalendarDays(79,thirdMonth,thirdYear)">17</span></li>
			<li><span :id="createIdForCalendarDays(80,thirdMonth,thirdYear)">18</span></li>
			<li><span :id="createIdForCalendarDays(81,thirdMonth,thirdYear)">19</span></li>
			<li><span :id="createIdForCalendarDays(82,thirdMonth,thirdYear)">20</span></li>
			<li><span :id="createIdForCalendarDays(83,thirdMonth,thirdYear)">21</span></li>
			<li><span :id="createIdForCalendarDays(84,thirdMonth,thirdYear)">22</span></li>
			<li><span :id="createIdForCalendarDays(85,thirdMonth,thirdYear)">23</span></li>
			<li><span :id="createIdForCalendarDays(86,thirdMonth,thirdYear)">24</span></li>
			<li><span :id="createIdForCalendarDays(87,thirdMonth,thirdYear)">25</span></li>
			<li><span :id="createIdForCalendarDays(88,thirdMonth,thirdYear)">26</span></li>
			<li><span :id="createIdForCalendarDays(89,thirdMonth,thirdYear)">27</span></li>
			<li><span :id="createIdForCalendarDays(90,thirdMonth,thirdYear)">28</span></li>
			<div class="adjust-bottom-row">
				<li class="space-between-bottom-row-dates"><span :id="createIdForCalendarDays(91,thirdMonth,thirdYear)">29</span></li>
				<li class="space-between-bottom-row-dates" :class="thirdMonthDays == 30 || thirdMonthDays == 31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(92,thirdMonth,thirdYear)">30</span></li>
				<li class="space-between-bottom-row-dates" :class="thirdMonthDays == 31 ? 'show' : 'hide'"><span :id="createIdForCalendarDays(93,thirdMonth,thirdYear)">31</span></li>
			</div>
			
		</ul>
	</div>
</template>

<script>

export default {
	name: "MultiCalendar",
	props: {
		cycleData: Object,
        cycleDurationUnit: String,
		cycleDurationNumber: Number,
		schedule: Object
	},
	data() {
		return {
			firstMonth: null,
			firstYear: null,
            secondMonth: null,
            secondYear: null,
            thirdMonth: null,
            thirdYear: null,
			millisecondsInADay: 86400000,
			currentMonth:0,
			currentMonthValue:"",
			currentYear:0,
			firstMonthDays:0,
			secondMonthDays: 0,
			thirdMonthDays:0,
			previousMonthValue:0,
			consecutiveMonths:false,
			weekDaysFirstMonth:[],
			weekDaysSecondMonth:[],
			weekDaysThirdMonth:[],
			excludedDays:[],
			seperateWindows:[],

			firstMonthNumberedDaysForSun:[],
			firstMonthNumberedDaysForMon:[],
			firstMonthNumberedDaysForTue:[],
			firstMonthNumberedDaysForWed:[],
			firstMonthNumberedDaysForThu:[],
			firstMonthNumberedDaysForFri:[],
			firstMonthNumberedDaysForSat:[],

			secondMonthNumberedDaysForSun:[],
			secondMonthNumberedDaysForMon:[],
			secondMonthNumberedDaysForTue:[],
			secondMonthNumberedDaysForWed:[],
			secondMonthNumberedDaysForThu:[],
			secondMonthNumberedDaysForFri:[],
			secondMonthNumberedDaysForSat:[],

			thirdMonthNumberedDaysForSun:[],
			thirdMonthNumberedDaysForMon:[],
			thirdMonthNumberedDaysForTue:[],
			thirdMonthNumberedDaysForWed:[],
			thirdMonthNumberedDaysForThu:[],
			thirdMonthNumberedDaysForFri:[],
			thirdMonthNumberedDaysForSat:[],
		};
					
	},
	created() {
        this.processCycleData();
	},
	mounted() {
		if(this.cycleDurationNumber > 1){ this.consecutiveMonths = false;}
		else{ this.consecutiveMonths = true}
	},
    watch: {
        cycleDurationUnit(){},
    },

	methods: {
        processCycleData() {
			console.log("this is the cycle data", this.cycleData.cycles);
			console.log("this is the exclude days schedule", this.schedule.windows);

			if(this.schedule.windows.length > 1) {
				for(let i = 0; i < this.schedule.windows.length; i++) {
					let splitDays = this.schedule.windows[i].windowStart.excludeDays.split(",");
					for(let j =0; j < splitDays.length; j++) {
						let windowAndDay = i+":"+ splitDays[j]+":"+ new Date(this.cycleData.cycles[i].windows[i].windowStart).getDate() + ":"+new Date(this.cycleData.cycles[i].windows[i].windowEnd).getDate();
						this.seperateWindows.push(windowAndDay);
						this.excludedDays.push(splitDays[j]);
					}
				} 
			}
			else {
				this.excludedDays = this.schedule.windows[0].windowStart.excludeDays.split(",");
			}

			console.log("this is the exclude days", this.excludedDays);
			console.log("this is the seperate windows", this.seperateWindows);
			
            this.cycleData.cycles.forEach((item,index) => {
                this.getMonthAndYear(item, index);
            });
        },
		getMonthAndYear(cycle, index) {
            if(index == 0) {
                this.firstMonth = new Date(cycle.cycleStart).toLocaleString('default', {month: 'long'});
			    this.firstYear = new Date(cycle.cycleStart).getFullYear();
				let monthNumber = new Date(cycle.cycleStart).getMonth()+1;
				this.firstMonthDays =  new Date(this.firstYear, monthNumber,0).getDate();

				let options ={weekday: "short" };
				let longOption = {weekday: "long"};
				for(let i = 1; i <= this.firstMonthDays; i++) {
					let testDate = new Date(this.firstYear+"-"+monthNumber+"-"+i);
					let day = testDate.getDay();
					if(this.weekDaysFirstMonth.length <=6) {
						
						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Sunday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForSun, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Monday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForMon, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Tuesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForTue, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Wednesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForWed, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Thursday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForThu, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Friday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForFri, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Saturday") { this.findNumberedDaysForTheDaysOfTheWeek(this.firstMonthNumberedDaysForSat, i)};

						this.weekDaysFirstMonth.push(new Intl.DateTimeFormat("en-US", options).format(testDate));
					}
				}

                this.setScheduleDates(cycle,this.firstMonth, this.firstYear);
				
            }
            if(index == 1) {
                this.secondMonth = new Date(cycle.cycleStart).toLocaleString('default', {month: 'long'});
			    this.secondYear = new Date(cycle.cycleStart).getFullYear();
				let monthNumber = new Date(cycle.cycleStart).getMonth()+1;
				this.secondMonthDays =  new Date(this.secondYear, monthNumber,0).getDate();

				let options ={weekday: "short" };
				let longOption = {weekday: "long"};
				for(let i = 1; i <= this.secondMonthDays; i++) {
					let testDate = new Date(this.secondYear+"-"+monthNumber+"-"+i);
					let day = testDate.getDay();
					if(this.weekDaysSecondMonth.length <=6) {

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Sunday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForSun, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Monday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForMon, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Tuesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForTue, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Wednesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForWed, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Thursday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForThu, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Friday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForFri, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Saturday") { this.findNumberedDaysForTheDaysOfTheWeek(this.secondMonthNumberedDaysForSat, i)};

						this.weekDaysSecondMonth.push(new Intl.DateTimeFormat("en-US", options).format(testDate));
					}
				}
				
                this.setScheduleDates(cycle,this.secondMonth, this.secondYear);
            }
            if(index == 2) {
                this.thirdMonth = new Date(cycle.cycleStart).toLocaleString('default', {month: 'long'});
			    this.thirdYear = new Date(cycle.cycleStart).getFullYear();
				let monthNumber = new Date(cycle.cycleStart).getMonth()+1;
				this.thirdMonthDays =  new Date(this.thirdYear, monthNumber,0).getDate();

				let options ={weekday: "short" };
				let longOption = {weekday: "long"};
				for(let i = 1; i <= this.thirdMonthDays; i++) {
					let testDate = new Date(this.thirdYear+"-"+monthNumber+"-"+i);
					let day = testDate.getDay();
					if(this.weekDaysThirdMonth.length <=6) {

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Sunday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForSun, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Monday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForMon, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Tuesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForTue, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Wednesday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForWed, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Thursday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForThu, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Friday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForFri, i)};

						if(new Intl.DateTimeFormat("en-US", longOption).format(testDate) == "Saturday") { this.findNumberedDaysForTheDaysOfTheWeek(this.thirdMonthNumberedDaysForSat, i)};

						this.weekDaysThirdMonth.push(new Intl.DateTimeFormat("en-US", options).format(testDate));
					}
				}
				
                this.setScheduleDates(cycle,this.thirdMonth, this.thirdYear);
            }
		},

		findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay) {

			dayOfTheWeekList.push(firstNumberedDay);

			let nextInstance = firstNumberedDay +7;
			dayOfTheWeekList.push(nextInstance);

			let followingInstance = nextInstance + 7;
			dayOfTheWeekList.push(followingInstance);

			let nextFollowingInstance = followingInstance + 7;// this might not exist since there is not always 4 of a particular day of a week in a month
			dayOfTheWeekList.push(nextFollowingInstance);// this might not exist since there is not always 4 of a particular day of a week in a month

			let lastPossibleInstance = nextFollowingInstance + 7;// this might not exist since there is not always 5 of a particular day of a week in a month
			dayOfTheWeekList.push(lastPossibleInstance);// this might not exist since there is not always 5 of a particular day of a week in a month
		},

		findDayOfWeekToAddToList(testDate, option, dayOfTheWeekList, firstNumberedDay) { // this is not called yet, want to get base functionality first then try this refactored portion after TODO 
			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Sunday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Monday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Tuesday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Wednesday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Thursday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Friday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};

			if(new Intl.DateTimeFormat("en-US", option).format(testDate) == "Saturday") { this.findNumberedDaysForTheDaysOfTheWeek(dayOfTheWeekList, firstNumberedDay)};


		},

		createIdForCalendarDays(day,month,year) {
			//will need to clean this up I only use the day for the id and not the month and year like previously 
			//TODO
			let calendarDayWithMonthAndYear = `day-${day}`;
			return calendarDayWithMonthAndYear;
		},


		filterDownTheExcludeDays(theMonthNumber) {
			let daysToExclude = [];
			for(let i = 0; i < this.seperateWindows.length; i++) {
				let splitSeperateWindows = this.seperateWindows[i].split(":");
				console.log("this is the split seperation windows", splitSeperateWindows);
				for(let j = 0; j < 1; j++ ) {
					let startDate = splitSeperateWindows[2];
					let endDate = splitSeperateWindows[3];

					//daysToExclude += this.getDaysToExclude(splitSeperateWindows,theMonthNumber, startDate, endDate);

					for(let k = startDate; k <= endDate; k++) {
						if(splitSeperateWindows[1] == "Wednesday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForWed.includes(k)) daysToExclude.push(k);
						}
						if(splitSeperateWindows[1] == "Wednesday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForWed.includes(k)) daysToExclude.push(k);
						}
						if(splitSeperateWindows[1] == "Wednesday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForWed.includes(k)) daysToExclude.push(k);
						}


						else if(splitSeperateWindows[1] == "Thursday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForThu.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Thursday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForThu.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Thursday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForThu.includes(k)) daysToExclude.push(k);
						}


						else if(splitSeperateWindows[1] == "Friday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForFri.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Friday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForFri.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Friday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForFri.includes(k)) daysToExclude.push(k);
						}


						else if(splitSeperateWindows[1] == "Saturday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForSat.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Saturday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForSat.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Saturday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForSat.includes(k)) daysToExclude.push(k);
						}


						else if(splitSeperateWindows[1] == "Sunday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForSun.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Sunday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForSun.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Sunday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForSun.includes(k)) daysToExclude.push(k);
						}


						else if(splitSeperateWindows[1] == "Monday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForMon.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Monday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForMon.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Monday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForMon.includes(k)) daysToExclude.push(k);
						}
						

						else if(splitSeperateWindows[1] == "Tuesday" && theMonthNumber == 1) {
							if(this.firstMonthNumberedDaysForTue.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Tuesday" && theMonthNumber == 2) {
							if(this.secondMonthNumberedDaysForTue.includes(k)) daysToExclude.push(k);
						}
						else if(splitSeperateWindows[1] == "Tuesday" && theMonthNumber == 3) {
							if(this.thirdMonthNumberedDaysForTue.includes(k)) daysToExclude.push(k);
						}

						else{
							console.log("this is k", k);
						}
					}
				}
			}
			console.log("this is the new array", daysToExclude);
			return daysToExclude;
			
		},

		setScheduleDates(cycle, month,year) {

			let firstMonthExcludeDays = [];
			let secondMonthExcludeDays = [];
			let thirdMonthExcludeDays = [];

			for(let j = 0; j < this.excludedDays.length; j++) {
				if(this.excludedDays[j]=== "Sunday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForSun);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForSun);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForSun);
				} 
				if(this.excludedDays[j]=== "Monday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForMon);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForMon);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForMon);
				} 
				if(this.excludedDays[j]=== "Tuesday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForTue);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForTue);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForTue);
				} 
				if(this.excludedDays[j]=== "Wednesday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForWed);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForWed);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForWed);
				} 
				if(this.excludedDays[j]=== "Thursday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForThu);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForThu);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForThu);
				} 
				if(this.excludedDays[j]=== "Friday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForFri);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForFri);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForFri);
				} 
				if(this.excludedDays[j]=== "Saturday") {
					firstMonthExcludeDays = firstMonthExcludeDays.concat(this.firstMonthNumberedDaysForSat);
					secondMonthExcludeDays = secondMonthExcludeDays.concat(this.secondMonthNumberedDaysForSat);
					thirdMonthExcludeDays = thirdMonthExcludeDays.concat(this.thirdMonthNumberedDaysForSat);
				} 
			}
			firstMonthExcludeDays = this.filterDownTheExcludeDays(1);
			secondMonthExcludeDays = this.filterDownTheExcludeDays(2);
			thirdMonthExcludeDays = this.filterDownTheExcludeDays(3);
		  
            for(let i=0; i< cycle.windows.length; i++) {
                let startDateWithoutOffest = new Date(cycle.windows[i].windowStart);
		        let endDateWithoutOffest = new Date(cycle.windows[i].windowEnd);
			    let startDate = new Date(startDateWithoutOffest).getDate();
			    let endDate = new Date(endDateWithoutOffest).getDate();
                let startMonth = new Date(startDateWithoutOffest).getMonth();
                let endMonth = new Date(endDateWithoutOffest).getMonth(); 
                let difference = (Number(endDateWithoutOffest) - Number(startDateWithoutOffest))/this.millisecondsInADay;
				let goesIntoAnotherMonth = startDate > endDate;
				
                setTimeout(() => {
					if(i == 0) this.currentMonth++;
					//93 days is the maximum amount of days that are possible in the three calendars
                    if(difference > 93) {
                        for (let day = startDate; day <= 93; day++) {
				            document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
			            }
                    }
                    else {

						if(goesIntoAnotherMonth) this.handleScheduleAcrossMonths(startDate, endDate, this.currentMonth, month,year, startDateWithoutOffest);
						if(this.currentMonth == 1 && !goesIntoAnotherMonth) {
							for (let day = startDate; day <= endDate; day++) {
								if(!firstMonthExcludeDays.includes(day)) {
									document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
								}
			            	}
						}
						if(this.currentMonth == 2 && !goesIntoAnotherMonth) {
							let firstDay = 32+(startDate-1);
							let lastDay = 32+(endDate-1);
							for (let day = firstDay; day <= lastDay; day++) {
								if(!secondMonthExcludeDays.includes(Number(document.getElementById(this.createIdForCalendarDays(day,month,year)).textContent))) {
									document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
								}
			            	}
						}
						if(this.currentMonth == 3 && !goesIntoAnotherMonth) {
							let firstDay = 63+(startDate-1);
							let lastDay = 63 +(endDate -1);
							for (let day = firstDay; day <= lastDay; day++) {
								if(!thirdMonthExcludeDays.includes(Number(document.getElementById(this.createIdForCalendarDays(day,month,year)).textContent))) {
									document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
								}			            	
			            	}
						}
                    }
				}, 50);
            }
		},

		handleScheduleAcrossMonths (startDate, endDate, currentMonth, month,year, startDateWithoutOffest) {
			
			let lastDay = 0;
			let firstDay = 0;
			if(currentMonth  == 1) {
				firstDay = startDate;
				lastDay = 31;
				this.previousMonthValue = startDateWithoutOffest.getMonth()+1;
			} 

			if(currentMonth == 2) {
				firstDay = startDate +31;
				lastDay = 63;
			} 

			if(currentMonth == 3) {
				firstDay = startDate + 62
				lastDay = 93;
			} 

			for (let day = firstDay; day <= lastDay; day++) {
				document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
			}

			if(currentMonth == 1 && this.cycleDurationUnit != "Years" && this.consecutiveMonths) {
				let firstDay = 32;
				let newEndDate = (firstDay + endDate)-1; // the -1 makes it inclusive of the first day
				for (let day = firstDay; day <= newEndDate; day++) {
					document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
				}
			}
			if(currentMonth == 2 && this.cycleDurationUnit != "Years" && this.consecutiveMonths) {
				let firstDay = 63;
				let newEndDate = (firstDay + endDate)-1; // the -1 makes it inclusive of the first day
				for (let day = firstDay; day <= newEndDate; day++) {
					document.getElementById(this.createIdForCalendarDays(day,month,year)).classList.add("active");
				}
			}
		},
	}
}

</script>
<style scoped>
* {box-sizing: border-box;}
ul {list-style-type: none;}
body {font-family: Verdana, sans-serif;}

.month {
	padding: 70px 25px;
	width: 95%;
	background: #5b88c0;
	text-align: center;
}

.month ul {
	margin: 0;
	padding: 0;
}

.month ul li {
	color: white;
	font-size: 20px;
	text-transform: uppercase;
	letter-spacing: 3px;
}

.month .prev {
	float: left;
	padding-top: 10px;
}

.month .next {
	float: right;
	padding-top: 10px;
}

.weekdays {
	margin: 0;
	padding: 10px 0;
	background-color: #ddd;
	width: 95%;
}

.weekdays li {
	display: inline-block;
	width: 13.6%;
	color: #666;
	text-align: center;
}

.days {
	padding: 10px 0;
	background: #eee;
	margin: 0;
	width: 95%;
}

.days li {
	list-style-type: none;
	display: inline-block;
	width: 13.6%;
	text-align: center;
	margin-bottom: 5px;
	font-size:12px;
	color: #777;
}

.days li .active {
	padding: 5px;
	background: #5b88c0;
	color: white !important
}

.hide {
	display: none !important;
}
.show {
	display: inline-block;
}

.warning {
	color: yellow;
}

.adjust-bottom-row {
	display: flex;
	justify-content: flex-start;
	margin-left: 7%;
	margin-top: 5px;
}

.space-between-bottom-row-dates {
	margin-right: 1%;
	text-align: left !important;
}

</style>